export default {
	inserted: function (el) {
		el.setAttribute('auto-grow', '');
	},
};